// Bridges to native Capacitor plugins when running inside the iOS/Android shell; falls back to web APIs otherwise.
const cap=()=>(window as any).Capacitor;
export const isNativeShell=()=>!!cap()?.isNativePlatform?.();
export const nativeShare=async(data:{title?:string;text:string;url?:string}):Promise<boolean>=>{
 const Share=cap()?.Plugins?.Share;
 try{if(Share){await Share.share({title:data.title,text:data.text,url:data.url,dialogTitle:data.title});return true;}
  if((navigator as any).share){await (navigator as any).share(data);return true;}}catch{}
 return false;
};
export const nativePickPhoto=async():Promise<File|null>=>{
 const Camera=cap()?.Plugins?.Camera;if(!Camera)return null;
 try{const p=await Camera.getPhoto({quality:80,resultType:'dataUrl',source:'PROMPT',promptLabelHeader:'Photo',promptLabelPhoto:'Galerie',promptLabelPicture:'Prendre une photo',correctOrientation:true,width:1600});
  const res=await fetch(p.dataUrl);const blob=await res.blob();return new File([blob],`photo.${p.format||'jpeg'}`,{type:blob.type||'image/jpeg'});}catch{return null;}
};
